import Big from 'Common/utils/customBig';

const adaptOmContractRequestData = data => ({
	...data,
	insurance: data.insurance ? Number(Big(data.insurance).div(100).toString()) : data.insurance,
});

export default adaptOmContractRequestData;
